import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { ArrowRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Collapse,
  Flex,
  Link,
  Switch,
  Text,
  useBreakpointValue,
  useToast,
  Image
} from "@chakra-ui/react";

import { FormPF, FormPJ } from "@/components/Form";
import { SEO } from "@/components/SEO";
import { ContentBox, Layout } from "@/layout";
import { useLoading } from "@/contexts/LoadingContext";
import { Logo } from "@/components/Header/Logo";
import { CardLoginIdent } from "@/components/Cards";
import { CardRequestNewPasswordIdent } from "@/components/Cards/CardRequestNewPasswordIndent";

type statusLog = {
  startLogin?: boolean;
  startRegister?: boolean;
  startCreate?: boolean;
};

export function CollapseLog({ startLogin, startRegister, startCreate }: statusLog) {
  const [wantLogin, setWantLogin] = useState(startLogin);
  const [wantRegister, setWantRegister] = useState(startRegister);
  const [wantCreate, setWantCreate] = useState(startCreate);

  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });
  const [isPF, setPF] = useState(false);

  return (
    <>
      <Collapse in={wantLogin} animateOpacity>
        <Flex
          direction={"column"}
          border={"1px solid #ECECEC"}
          bgColor={"ll-white.main"}
          borderRadius={"10px"}
          padding={"20px"}
        >
          <Text
            textAlign={"center"}
            color={"ll-blue.main"}
            fontSize={"titleProduct"}
            fontWeight={"500"}
            letterSpacing={"-1px"}
            cursor={"default"}
          >
            Faça seu login
          </Text>
          <CardLoginIdent
            checkout={true}
            setWantLogin={setWantLogin}
            setWantRegister={setWantRegister}
            setWantCreate={setWantCreate}
          />
        </Flex>
      </Collapse>
      <Collapse in={wantCreate} animateOpacity>
        <Flex
          direction={"column"}
          border={"1px solid #ECECEC"}
          bgColor={"ll-white.main"}
          borderRadius={"10px"}
          padding={"20px"}
        >
          <Flex
            direction={"column"}
            justifyContent={["center", "center"]}
            alignItems={["center", "center"]}
            mt="5px"
            mb="2rem"
            width="100%"
          >
            <Flex width="100%" alignItems={["center", "center"]}>
              <Flex>
                <Image
                  src="https://cdn.pneufree.com.br/LINGLONG/images/Geral/arrow.svg"
                  boxSize={"15px"}
                  transform={"rotate(180deg)"}
                  mt={"3px"}
                  mr={"5px"}
                />
                <Link
                  color={"black"}
                  fontSize={"14px"}
                  textStyle={"Regular"}
                  onClick={() => {
                    setWantCreate(false);
                    setWantLogin(true);
                    setWantRegister(false);
                  }}
                >
                  Voltar
                </Link>
              </Flex>
              <Text
                textAlign={"center"}
                color={"ll-blue.main"}
                ml={"20%"}
                fontSize={"titleProduct"}
                fontWeight={"500"}
                letterSpacing={"-1px"}
                mb={"25px"}
                cursor={"default"}
              >
                Cadastro
              </Text>
            </Flex>
            <Flex alignItems="center" order={!isWideVersion && 3}>
              <Text textStyle={"Bold"} fontSize="text1" color={!isPF ? "black" : "gray.300"}>
                PESSOA FÍSICA
              </Text>
              <Flex>
                <Switch
                  m="0 10px"
                  // id="email-alerts"
                  colorScheme={"green"}
                  size="lg"
                  onChange={() => setPF((prev) => !prev)}
                  isChecked={isPF}
                />
              </Flex>
              <Text textStyle={"Bold"} fontSize="text1" color={isPF ? "black" : "gray.300"}>
                PESSOA JURÍDICA
              </Text>
            </Flex>
          </Flex>

          {/* {!isPF ? <FormRegister /> : <FormPj />} */}
          <Flex justify={"center"}>
            {!isPF ? (
              <FormPF checkout={true} customWidth={"100%"} />
            ) : (
              <FormPJ checkout={true} customWidth={"100%"} />
            )}
          </Flex>
        </Flex>
      </Collapse>
      <Collapse in={wantRegister} animateOpacity>
        <Flex
          direction={"column"}
          border={"1px solid #ECECEC"}
          bgColor={"ll-white.main"}
          borderRadius={"10px"}
          padding={"20px"}
        >
          <Text
            textAlign={"center"}
            color={"ll-blue.main"}
            fontSize={"titleProduct"}
            fontWeight={"500"}
            letterSpacing={"-1px"}
            cursor={"default"}
          >
            Recuperar senha
          </Text>
          <CardRequestNewPasswordIdent
            setWantLogin={setWantLogin}
            setWantRegister={setWantRegister}
            setWantCreate={setWantCreate}
          />
        </Flex>
      </Collapse>
    </>
  );
}
